var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetwork = function SvgNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "data-name": "21 - Signal",
    viewBox: "-1.93 0 30 30"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 21.2a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3V27a3 3 0 0 0 3 3h.2a3 3 0 0 0 3-3ZM12.85 27V15.6a3 3 0 0 0-3-3h-.2a3 3 0 0 0-3 3V27a3 3 0 0 0 3 3h.2a3 3 0 0 0 3-3M19.5 8.869a3 3 0 0 0-3-3h-.2a3 3 0 0 0-3 3V27a3 3 0 0 0 3 3h.2a3 3 0 0 0 3-3Z"
  })));
};
export default SvgNetwork;